import { render, staticRenderFns } from "./DepartmentEnrollment.vue?vue&type=template&id=dc1e03ae&"
import script from "./DepartmentEnrollment.vue?vue&type=script&lang=js&"
export * from "./DepartmentEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports